import { C } from 'jssip'

const {
  CANCELED,
  NO_ANSWER,
  REJECTED,
  ADDRESS_INCOMPLETE,
  CONNECTION_ERROR,
} = C.causes

const callMissed = 'call-missed'
const callRejected = 'call-rejected'
// const transferFailed = 'transfer-failed' // TODO implement
const callAnsweredElsewhere = 'call-answered-elsewhere'
const callFailed = 'call-failed'

const NOTIFICATIONS = {
  list: [callMissed, callRejected, callAnsweredElsewhere],
  names: {
    callMissed,
    callRejected,
    callAnsweredElsewhere,
  },
  sessionMap: {
    remote: {
      [CANCELED]: callMissed,
      [ADDRESS_INCOMPLETE]: callFailed,
      [CONNECTION_ERROR]: callFailed,
    },
    local: {
      [NO_ANSWER]: callMissed,
      [REJECTED]: callRejected,
      [ADDRESS_INCOMPLETE]: callFailed,
      [CONNECTION_ERROR]: callFailed,
    },
  },
}

export default NOTIFICATIONS
